import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// Self-hosted fonts — no Google Fonts CDN dependency
import "@fontsource/albert-sans/300.css";
import "@fontsource/albert-sans/400.css";
import "@fontsource/albert-sans/500.css";
import "@fontsource/albert-sans/600.css";
import "@fontsource/albert-sans/700.css";
import "@fontsource/material-symbols-outlined/400.css";
import "./styles/indaco.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
